import { CLIENT_TYPE, Condition } from '@upstart/harmony/lib/constants';

export enum Action {
  START = 'start',
  SAVE = 'save',
  REVERT = 'revert',
}

export enum VehicleSelectedAction {
  ADDOTHER_VIN_START = 'addother_vin_start',
  ADDOTHER_MANUALLY_START = 'addother_manually_start',
  ADDOTHER_MANUALLY_CANCEL = 'addother_manually_cancel',
  ADDOTHER_MANUALLY_FINISH = 'addother_manually_finish',
}

export const amplitudeEvents = {
  DESKING_PENCIL_SEND_SALESPERSON_FINISH:
    'desking_pencil_sendsalesperson_finish',
  DESKING_PENCIL_SEND_SALESPERSON_ERROR: 'desking_pencil_sendsalesperson_error',
  DESKING_EDIT_RIC_START: 'desking_edit_ric_start',
  DESKING_EDIT_RIC_FINISH: 'desking_edit_ric_finish',
} as const;

export const amplitudeEventsPricing = {
  [CLIENT_TYPE.IN_STORE]: {
    [Condition.NEW]: {
      [Action.START]: 'pricinginventory_instore_new_start',
      [Action.SAVE]: 'pricinginventory_instore_new_save',
      [Action.REVERT]: 'pricinginventory_instore_new_revert',
    },
    [Condition.USED]: {
      [Action.START]: 'pricinginventory_instore_used_start',
      [Action.SAVE]: 'pricinginventory_instore_used_save',
      [Action.REVERT]: 'pricinginventory_instore_used_revert',
    },
    [Condition.CPO]: {
      [Action.START]: 'pricinginventory_instore_cpo_start',
      [Action.SAVE]: 'pricinginventory_instore_cpo_save',
      [Action.REVERT]: 'pricinginventory_instore_cpo_revert',
    },
  },
  [CLIENT_TYPE.ONLINE]: {
    [Condition.NEW]: {
      [Action.START]: 'pricinginventory_online_new_start',
      [Action.SAVE]: 'pricinginventory_online_new_save',
      [Action.REVERT]: 'pricinginventory_online_new_revert',
    },
    [Condition.USED]: {
      [Action.START]: 'pricinginventory_online_used_start',
      [Action.SAVE]: 'pricinginventory_online_used_save',
      [Action.REVERT]: 'pricinginventory_online_used_revert',
    },
    [Condition.CPO]: {
      [Action.START]: 'pricinginventory_online_cpo_start',
      [Action.SAVE]: 'pricinginventory_online_cpo_save',
      [Action.REVERT]: 'pricinginventory_online_cpo_revert',
    },
  },
} as const;

export const amplitudeEventsDeskingCTR = {
  FINANCE_START_ECONTRACT_CLICKED: 'finance_start_econtract_clicked',
  FINANCE_START_ECONTRACT_FINISHED: 'finance_start_econtract_finished',
};
